import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { API_TIMEOUT_TIERS, getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { enterpriseClient } from '#pplx_generated/typespec/rest/enterprise/client.js';
const EMPTY_RESPONSE = {
    organization: null,
    redirectToEnterpriseOrigin: false,
};
export const getLoginDetailsFromEmail = async ({ email, headers, reason, }) => {
    if (!email) {
        throw new Error('NO_EMAIL_ADDRESS');
    }
    try {
        const { data, error, response } = await enterpriseClient.POST(`/rest/enterprise/organization/login/details`, reason, {
            headers,
            timeoutMs: getQueryTimeoutMs({
                productionMs: API_TIMEOUT_TIERS.MEDIUM,
            }),
            numRetries: 1,
            reason,
            body: {
                email,
            },
        });
        if (error) {
            throw new ApiClientsError('API_CLIENTS_ERROR', {
                cause: error,
                status: response.status ?? 0,
                details: {
                    reason,
                },
            });
        }
        return {
            organization: data?.organization ?? null,
            redirectToEnterpriseOrigin: data?.redirect_to_enterprise_origin ?? false,
        };
    }
    catch (err) {
        logger.error(`Failed to get login details`, { email, err });
        return EMPTY_RESPONSE;
    }
};
//# sourceMappingURL=ssoQueries.js.map